import request from '@/lib/request';

const api = {};

// 生成邀请码
api.inviteGetCode = (reqData, autoErrorTips = false) => request({
  url: 'v3/user/invite/get_code',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 查询邀请信息
api.getInviteInfo = (reqData, autoErrorTips = false) => request({
  url: 'v1/user/invite/inviter_info',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 接受邀请（简化注册）
api.acceptInvite = (reqData, autoErrorTips = false) => request({
  url: 'v1/user/invite/accept',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

export default api;
